import { MessageCircle, Phone, CalendarCheck } from "lucide-react";
import { TEL_LINK, waLink, WA_MESSAGES } from "../data/firm";
import { useConsultation } from "../context/ConsultationContext";

export const FloatingActions = () => {
  const { openConsultation } = useConsultation();
  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col items-end gap-2.5 sm:bottom-6 sm:right-6" data-testid="floating-actions">
      <button
        onClick={() => openConsultation()}
        data-testid="floating-consultation-button"
        aria-label="Get consultation"
        className="flex h-12 items-center gap-2 rounded-full bg-navy px-4 text-xs font-bold uppercase tracking-widest text-white shadow-lg shadow-navy/25 transition-transform hover:scale-105 sm:hidden"
      >
        <CalendarCheck className="h-4 w-4" /> Consult
      </button>
      <a
        href={TEL_LINK}
        data-testid="floating-call-button"
        aria-label={`Call ${"9518759333"}`}
        className="flex h-12 w-12 items-center justify-center rounded-full bg-corpblue text-white shadow-lg shadow-corpblue/30 transition-transform hover:scale-105"
      >
        <Phone className="h-5 w-5" />
      </a>
      <a
        href={waLink(WA_MESSAGES.general)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 transition-transform hover:scale-105"
      >
        <MessageCircle className="h-6 w-6" fill="currentColor" strokeWidth={0} />
      </a>
    </div>
  );
};
